import { createSlice } from '@reduxjs/toolkit';
import { createScopedStore, createIndependentStore } from '@utils/react';

function makePm2ConfigStore(state) {
  const slice = createSlice({
    name: "@pm2/config-store",
    initialState: state,
    reducers: {
      updateAudience(state2, action) {
        state2.config.theme.targetAudience = action.payload;
      }
    }
  });
  return createIndependentStore(slice);
}
const pm2ConfigStore = createScopedStore(
  makePm2ConfigStore({
    previewMode: false,
    host: "",
    baseUrl: "",
    fallbackMetaDescription: {},
    config: {
      id: "",
      uniqueId: "",
      title: "",
      homePath: "",
      searchPath: "",
      settings: {
        footerColumns: [],
        trialAccessUrl: "",
        enableGeoGebra: false,
        enableSleeknote: false,
        enableTableOfContentsForCourses: false,
        showCoursePlanner: false,
        loginProvider: "gu-all",
        showCourseFrontpages: false,
        loginFreeAccess: false,
        loginDisabled: false,
        ordbogenDotComEnabled: false
      },
      theme: {
        targetAudience: "Grade7To9",
        logo: {
          subject: ""
        },
        color: {
          publisher: "220 67 32",
          primary: "#fff",
          secondary: "#fff",
          tertiary: "#fff"
        },
        surfaces: {
          box1: {
            color: "#fff",
            stroked: false
          },
          box2: {
            color: "#fff",
            stroked: false
          },
          box3: {
            color: "#fff",
            stroked: false
          },
          snippet: {
            color: "#fff",
            stroked: false
          }
        },
        componentPreviewImage: void 0,
        favIconImage: void 0,
        productLogoImage: void 0
      }
    }
  })
);

export { makePm2ConfigStore, pm2ConfigStore };
//# sourceMappingURL=store.config.js.map
